export default __webpack_public_path__ + "static/media/dayne_davis.8772a6fa.jpg";